/* eslint-disable @typescript-eslint/no-empty-function */ import { createFormControl } from '../../lib/react-hook-form';
const DUMMY_CONTROL = new Proxy({}, {
    get (_, prop) {
        // Handle specific properties that useController needs
        if (prop === '_options') {
            return {
                disabled: false,
                mode: 'onChange'
            };
        }
        if (prop === '_formState') {
            return {
                disabled: false,
                isDirty: false,
                isValid: true,
                errors: {}
            };
        }
        if (prop === '_subjects') {
            return {
                values: {
                    next: ()=>{}
                },
                state: {
                    next: ()=>{}
                },
                array: {
                    next: ()=>{}
                }
            };
        }
        if (prop === '_names') {
            return {
                mount: new Set(),
                unMount: new Set(),
                array: new Set(),
                watch: new Set()
            };
        }
        // For testing purposes
        if (prop === '__isDummyControl') {
            return true;
        }
        // For any other property, return a safe default
        if (typeof prop === 'string') {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        return undefined;
    }
});
let cachedControl;
/**
 * Return a dummy control object for use when a form controlled is used outside of a form context.
 */ export function getDummyControl() {
    if (cachedControl === undefined) {
        // Component is rendered outside of a form context, but we have react-hook-form < v7.55.
        if (typeof createFormControl === 'function') {
            cachedControl = createFormControl().control;
        } else {
            // Component is rendered outside of a form context, but we have react-hook-form >= v7.55.
            cachedControl = DUMMY_CONTROL;
        }
    }
    return cachedControl;
}

//# sourceMappingURL=dummyControl.js.map